import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { isSubscriptionPurchaseNotificationDetails as typeGuard } from "@scrile/api-provider/dist/api/SubscriptionProvider";

export { default } from "./NotificationSubscriptionPurchase.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
